// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import VerifyRoundSvg from '@rsuite/icon-font/lib/status/VerifyRound';
var VerifyRound = createSvgIcon({
  as: VerifyRoundSvg,
  ariaLabel: 'verify round',
  category: 'status',
  displayName: 'VerifyRound'
});
export default VerifyRound;